<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Sauvegardes",
          icon: "bi bi-cloud-arrow-down-fill",
          route: "backups-index",
        },
      ],
    };
  },
};
</script>
